import { Link } from "react-router-dom"
import "./footer.css"

export function Footer(){
    return (
        <div className="footer bg-black pt-3">
            <div className="d-flex flex-wrap footer-info justify-content-between text-white mx-auto py-2 pt-5">
                <div className="d-flex flex-column gap-2 footer-exclusive">
                    <h4>Exclusive</h4>
                    <h5>Subscribe</h5>
                    <p>Get 10% off your first order</p>
                    <div className="d-flex cntr border rounded-1">
                        <input type="text" placeholder="Enter your email" />
                        <div className="input-icon"></div>
                    </div>
                </div>
                <div className="d-flex flex-column footer-support">
                    <h5>Support</h5>
                    <p>111 Bijoy sarani, Dhaka, DH 1515, Bangladesh.</p>
                    <p>exclusive@gmail.com</p>
                    <p>+88015-88888 9999</p>
                </div>
                <div className="d-flex flex-column footer-account">
                    <h5>Account</h5>
                    <Link to="/account">My Account</Link>
                    <div className="mb-3">
                        <Link to="login">Login</Link>
                        <span> / </span>
                        <Link to="signup">Register</Link>
                    </div>
                    <Link to="/cart">Cart</Link>
                    <Link to="wishlist">Wishlist</Link>
                    <Link to="/shop">Shop</Link>
                </div>
                <div className="d-flex flex-column footer-links">
                    <h5>Quick Link</h5>
                    <p>Privacy Policy</p>
                    <p>Terms Of Use</p>
                    <p>FAQ</p>
                    <Link to="/contact">Contact</Link>
                </div>
                <div className="d-flex flex-column footer-download">
                    <h5>Download App</h5>
                    <div className="d-flex flex-column footer-app mt-1 mb-4">
                        <div>Save $3 with App New User Only</div>
                        <div className="d-flex gap-2 mt-1">
                            <div className="qr-code-image"></div>
                            <div className="d-flex flex-column footer-app-links justify-content-between">
                                <div className="google-play-btn"></div>
                                <div className="app-store-btn"></div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex social-links gap-4">
                        <div className="social-facebook"></div>
                        <div className="social-twitter"></div>
                        <div className="social-instagram"></div>
                        <div className="social-linkedin"></div>
                    </div>
                </div>
            </div>

            <hr />

            <div className="d-flex gap-2 cntr footer-copyright pb-3">
                <div className="copyright-icon"></div>
                <div>Copyright Rimel 2022. All right reserved</div>
            </div>
        </div>
    )
}